import ChooseReportView from './choose-report-form'
import i18n from 'scoreboard/components/i18n'

var ChooseReportPath = function() {
	return {
		steps: [{
			step: 'new',
			titleCode: 'report.common.new',
			stepCode: 'report.wizard.chooseReportType',
			confirmCode: 'common.next',
			view: ChooseReportView,
			validate: function (attr) {
				if (!attr.type) {
					return i18n.get('report.wizard.chooseReportType')
				}
			}
		}]
	}
}

export default ChooseReportPath

ChooseReportPath.__filename__ = 'reports/wizard/choose-report/choose-report-path.js'
